module.exports = "/images/vendor/lightbox2/dist/loading.gif?2299ad0b3f63413f026dfec20c205b8f";